var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3999 13.4002C2.3999 12.4061 3.20579 11.6002 4.1999 11.6002C5.19402 11.6002 5.9999 12.4061 5.9999 13.4002V20.6002C5.9999 21.5943 5.19402 22.4002 4.1999 22.4002C3.20579 22.4002 2.3999 21.5943 2.3999 20.6002V13.4002Z",
    fill: "#4318FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1999 13.2002V19.7169C7.1999 20.626 7.71351 21.457 8.52659 21.8635L8.5864 21.8934C9.25291 22.2267 9.98785 22.4002 10.733 22.4002H17.2324C18.3764 22.4002 19.3614 21.5927 19.5858 20.4709L21.0258 13.2709C21.3228 11.7858 20.1869 10.4002 18.6724 10.4002H14.3999V5.6002C14.3999 4.27471 13.3254 3.2002 11.9999 3.2002C11.3372 3.2002 10.7999 3.73745 10.7999 4.4002V5.2002C10.7999 6.23877 10.463 7.24933 9.8399 8.0802L8.1599 10.3202C7.53676 11.1511 7.1999 12.1616 7.1999 13.2002Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFull);
export default __webpack_public_path__ + "static/media/like-full.37a8d1e1684c16ec94bb49e8b5d234e8.svg";
export { ForwardRef as ReactComponent };